import { render, staticRenderFns } from "./formManagerList.vue?vue&type=template&id=296961b4&scoped=true&"
import script from "./formManagerList.vue?vue&type=script&lang=js&"
export * from "./formManagerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296961b4",
  null
  
)

export default component.exports